<div class="grid grid-cols-1 gap-x-8 gap-y-2 py-4 sm:py-10 md:grid-cols-3">
  <div #header class="md:sticky sm:top-0 py-1 sm:py-4 align-self-start">
    <ng-content select="[header]"></ng-content>
    @if (useDefaultTitle) {
      <h2 class="text-base/7 font-semibold text-gray-900">{{ title }}</h2>
      <p class="mt-1 text-sm/6 text-gray-600">{{ description }}</p>
    }
  </div>

  <form (submit)="$event.preventDefault()"
        class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 align-self-start">
    <div class="p-[1.75rem]">
      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
        <ng-content></ng-content>
      </div>
    </div>
  </form>
</div>
